import React, { useState } from 'react'

import { User, listUsers as apiListUsers } from '../../../services/users'

interface CommissionFormContextContent {
  partners: User[]
  loadingPartners: boolean
  listPartners: (search: string) => void
  employees: User[]
  loadingEmployees: boolean
  listEmployees: (search: string) => void
}

export const CommissionFormContext =
  React.createContext<CommissionFormContextContent>(
    {} as CommissionFormContextContent
  )

interface CommissionFormProviderProps {
  children: React.ReactNode
}

export const CommissionFormProvider: React.FC<CommissionFormProviderProps> = ({
  children
}) => {
  const [partners, setPartners] = useState<User[]>([])
  const [loadingPartners, setLoadingPartners] = useState(false)
  const [employees, setEmployees] = useState<User[]>([])
  const [loadingEmployees, setLoadingEmployees] = useState(false)

  function listPartners(search: string) {
    Promise.resolve()
      .then(() => setLoadingPartners(true))
      .then(() => apiListUsers({ search, role: 'PARTNER' }))
      .then(data => setPartners(data.users))
      .finally(() => setLoadingPartners(false))
  }

  function listEmployees(search: string) {
    Promise.resolve()
      .then(() => setLoadingEmployees(true))
      .then(() => apiListUsers({ search, role: 'EMPLOYEE' }))
      .then(data => setEmployees(data.users))
      .finally(() => setLoadingEmployees(false))
  }

  return (
    <CommissionFormContext.Provider
      value={{
        partners,
        loadingPartners,
        listPartners,
        employees,
        loadingEmployees,
        listEmployees
      }}
    >
      {children}
    </CommissionFormContext.Provider>
  )
}
